import noop from 'lodash/noop';

import { QuestionTypeEnum } from '@/types/schema';

import ENPSRating from '../../../components/ENPSRating';
import {
  QuestionEntityEditorProps,
  SurveyQuestionsField,
} from '../../../views/UserSurveyEditor/components/BlocksList/types';

const ENpsField: SurveyQuestionsField = {
  type: QuestionTypeEnum.Enps,
  Editor: (_: QuestionEntityEditorProps) => <ENPSRating onChange={noop} />,
};

export default ENpsField;
